import i18next from 'app/translations/i18n';

const QUIZ_TYPE_GUID = 'CTTY_09';
const QUIZ_LABEL = 'Quiz';
const LEGACY_QUIZ_LABEL = 'Test';

function isQuizLabel(name) {
  return typeof name === 'string' && name.trim().toLowerCase() === QUIZ_LABEL.toLowerCase();
}

// CTTY_09 es el tipo que los sistemas de datos posteriores identifican como "Quiz", así que se
// rotula siempre así, sea cual sea el nombre que traiga la BD del tenant. Si el tenant tiene otro
// tipo que ya se llamaba "Quiz", ese pasa a "Test" para que ambos sigan siendo distinguibles.
function getQuizLabel({ guid, name }) {
  if (guid === QUIZ_TYPE_GUID) return QUIZ_LABEL;

  return isQuizLabel(name) ? LEGACY_QUIZ_LABEL : null;
}

// Las traducciones por tenant (contents-types) tienen prioridad: son configuración explícita.
// Se pide con un centinela porque i18next no distingue "sin traducción" de otro modo: sin
// defaultValue devuelve la clave sin el namespace (el guid a pelo), y mientras no ha terminado de
// inicializarse devuelve la clave entera.
const NO_TRANSLATION = '__no_content_type_translation__';

function getTenantName(guid) {
  const key = `contents-types:${guid}`;
  const translated = i18next.t(key, { defaultValue: NO_TRANSLATION });

  return translated === NO_TRANSLATION || translated === key ? null : translated;
}

function resolveName(type) {
  return getTenantName(type.guid) ?? getQuizLabel(type) ?? type.name;
}

/**
 * Aplica las traducciones a los tipos de contenido
 * @param {Array} types - Array de tipos de contenido
 * @returns {Array} - Array de tipos con las traducciones aplicadas
 */
export function translateTypes(types) {
  if (!types || !Array.isArray(types)) {
    return types;
  }

  return types.map((type) => ({ ...type, name: resolveName(type) }));
}

/**
 * Aplica las traducciones a un tipo específico
 * @param {Object} type - Tipo de contenido
 * @returns {Object} - Tipo con la traducción aplicada
 */
export function translateType(type) {
  if (!type || !type.guid) {
    return type;
  }

  return { ...type, name: resolveName(type) };
}
